const actionTypesSelect = {
    ALERT_EMAIL: '📧 Alerta por Email',
    ALERT_SMS: '📱 Alerta por SMS',
    ALERT_TELEGRAM: '✈️ Alerta por Telegram',
    AI_ALERT: '🤖 Alerta IA (notifica sem ordem)',
    ORDER: '💱 Enviar Ordem',
    FUTURES_ORDER: '⚡ Ordem de Futuros',
    TRAILING: '📉 Trailing Stop',
    WITHDRAW: '💸 Saque de Cripto',
    ENABLE_AUTOMATION: '▶️ Ativar Automação',
    DISABLE_AUTOMATION: '⏸️ Desativar Automação'
}

// Tipos de ação específicos de cada MERCADO (escondidos no mercado oposto):
// spot esconde FUTURES_ORDER; futuros esconde os de spot (ORDER/TRAILING/WITHDRAW).
const spotOnlyActions = ['ORDER', 'TRAILING', 'WITHDRAW'];
const futuresOnlyActions = ['FUTURES_ORDER'];

const actionTypes = {
    ALERT_EMAIL: 'ALERT_EMAIL',
    ALERT_SMS: 'ALERT_SMS',
    ALERT_TELEGRAM: 'ALERT_TELEGRAM',
    AI_ALERT: 'AI_ALERT',
    AI_ANALYSIS: 'AI_ANALYSIS',
    AI_MARKET_SCAN: 'AI_MARKET_SCAN',
    ORDER: 'ORDER',
    FUTURES_ORDER: 'FUTURES_ORDER',
    WITHDRAW: 'WITHDRAW',
    TRAILING: 'TRAILING',
    GRID: 'GRID',
    ENABLE_AUTOMATION: 'ENABLE_AUTOMATION',
    DISABLE_AUTOMATION: 'DISABLE_AUTOMATION'
}

module.exports = {
    actionTypesSelect,
    actionTypes,
    spotOnlyActions,
    futuresOnlyActions
}